import { styled } from "@mui/material/styles"
import LogoImg from "assets/logo.svg"
import { ImgHTMLAttributes } from "react"

export const Logo = styled((props: ImgHTMLAttributes<HTMLImageElement>) => (
  <img src={LogoImg} {...props} />
))({
  display: "block",
})
